document.addEventListener("DOMContentLoaded", function () {
    const readTimeContainer = document.querySelector(".js-read-time");
    const contentElement = document.querySelector(".ss-article-content");

    if (readTimeContainer && contentElement) {
      const text = contentElement.textContent || "";
      const words = text.trim().split(/\s+/).length;
      const wordsPerMinute = 200;
      const time = Math.max(1, Math.ceil(words / wordsPerMinute));

      readTimeContainer.querySelector(".read-time__time").textContent = `${time} min Read`;
      readTimeContainer.style.display = "flex"; 
    }
  });
    const headings = document.querySelectorAll(".article__content h3");

    headings.forEach(h3 => {
        // Skip if number-bullet already exists
        if (h3.querySelector(".number-bullet")) return;

        // Find the first text node with actual content
        const walker = document.createTreeWalker(h3, NodeFilter.SHOW_TEXT, {
            acceptNode: node => node.nodeValue.trim().length > 0
                ? NodeFilter.FILTER_ACCEPT
                : NodeFilter.FILTER_SKIP
        });

        const textNode = walker.nextNode();
        if (textNode) {
            const text = textNode.nodeValue.trim();
            const firstChar = text.charAt(0);
            const restText = text.substring(1);

            // Update the text node
            textNode.nodeValue = restText;

            // Insert the span before the text node
            const span = document.createElement("span");
            span.classList.add("number-bullet");
            span.textContent = firstChar;
            textNode.parentNode.insertBefore(span, textNode);
        }
});
